import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/cn';
import { Icon } from '@/ui/common/icon';

export interface KreditBetSelectHeaderProps {
  onCancel?: () => void;
  className?: string;
}

/** Figma KreditBetSelectHeader — picker title with creditbetin icon. */
export function KreditBetSelectHeader({ onCancel, className }: KreditBetSelectHeaderProps) {
  const { t } = useTranslation();

  return (
    <div className={cn('flex h-11 w-full items-center gap-2', className)}>
      <Icon name="creditbetin" size={20} className="shrink-0 text-action-primary" />
      <p className="min-w-0 flex-1 truncate text-body-m font-bold text-text-primary">
        {t('SelectTicketForCreditBet', { defaultValue: 'Select Ticket for KreditBet' })}
      </p>
      {onCancel ? (
        <button
          type="button"
          onClick={onCancel}
          className="shrink-0 rounded-sm px-2 py-1 text-body-s font-bold text-text-secondary hover:bg-bg-elevated hover:text-text-primary"
        >
          {t('Cancel', { defaultValue: 'Cancel' })}
        </button>
      ) : null}
    </div>
  );
}
